<template lang="html">
    <div class="inner-modal">
        <div class="head-modal row">
            <div class="title column">
                <div class="head-modal-title">
                    Vérification d'identité
                </div>
                <div class="head-modal-emphase">
                    Sélectionnez le documents à vérifier
                </div>
            </div>
        </div>
        <div class="body-modal">
            <form class="form-ui column default-form-ui">
                <div class="ctn-docs row">
                    <div class="doc" v-for="(doc, key) in docs" v-bind:key="key" @click="select(key)">
                        <div class="select" :class="{ active: isSelected(key) }">
                            <img :src="good" alt="">
                        </div>
                        <tile-doc-selectable :doc="doc" />
                    </div>
                </div>
                <div class="footer-certified row">
                    <div class="side" v-if="docs.length === 0">
                        Aucun document justificatif enregistré
                    </div>
                    <router-link :to="{ name: 'Documents' }" class="side link" v-else>
                        Gérer les documents
                    </router-link>
                    <div class="ctn-cta right row">
                        <div class="btn btn-gold" @click="close">Annuler</div>
                        <div class="btn btn-red" v-if="docs.length > 0" @click="send">Envoyer</div>
                        <router-link :to="{ name: 'Documents' }" class="btn btn-red" v-if="docs.length === 0">Ajouter un document</router-link>
                    </div>
                </div>
            </form>
        </div>
  </div>
</template>

<script>
import emma from '@/common/services/Emma'
import TileDocSelectable from '@/common/components/tile-doc-selectable.vue'
import Good from '@/common/assets/img/good.svg'

export default {
	name: 'Certified',
	props: ['data'],
	components: {
		TileDocSelectable
	},
	data () {
		return {
			docs: [],
			good: Good,
			selected: [],
			idToUniversign: ['TYPE_ID_CARD', 'TYPE_PASSPORT', 'TYPE_TITRE_DE_SEJOUR', 'TYPE_DRIVE_LICENCE']
		}
	},
	mounted () {
		this.docs = []
		emma.get('api/documents/justificatifs/' + this.data.id).then((result) => {
			if (result.data.success) {
				this.docs = result.data.documents
			}
		}).catch((error) => {
			console.warn(error)
		})
	},
	methods: {
		close () {
			this.$emit('close')
		},
		send () {
			if (this.selected.length > 0) {
				const userId = this.data.id
				let documentsId = ''
				this.selected.forEach((key, index) => {
					documentsId += ((index !== 0) ? '_' : '') + this.docs[key].id
				})
                // const docType = this.idToUniversign[parseInt(this.docs[this.selected[0]].sub_category) - 1]
				const docType = parseInt(this.docs[this.selected[0]].sub_category) - 1

				if (docType !== null) {
					this.$store.commit('LOADER_IN')
					emma.get('api/universign/validation-account/' + userId + '/' + documentsId + '/' + docType).then((result) => {
						this.$store.commit('LOADER_OUT')
						if (result.data.success) {
							this.$notify({
								type: 'success',
								group: 'default',
								title: 'Les documents ont pu être validé',
								text: ''
							})
							this.close()
						} else {
							this.$notify({
								type: 'error',
								group: 'default',
								title: 'Les documents n\'ont pas pu être validé',
								text: ''
							})
						}
					}).catch(() => {
						this.$store.commit('LOADER_OUT')
						this.$notify({
							type: 'error',
							group: 'default',
							title: 'Les documents n\'ont pas pu être validé',
							text: ''
						})
					})
				} else {
					this.$notify({
						type: 'error',
						group: 'default',
						title: 'Ce fichier n\'est pas valide',
						text: ''
					})
				}
			} else {
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Il faut selectionner au moins un fichier',
					text: ''
				})
			}
		},
		select (key) {
			if (this.selected.indexOf(key) === -1) {
				this.selected.push(key)
			} else {
				this.selected.splice(this.selected.indexOf(key), 1)
			}
		},
		isSelected (key) {
			return (this.selected.indexOf(key) !== -1)
		}
	}
}
</script>

<style lang="scss" scoped>
.inner-modal {
    width: 600px;

    .head-modal {
        justify-content: flex-start;

        .title {
            align-items: flex-start;
        }
    }

    form {
        margin: 0;
        max-width: none;
    }

    .ctn-docs {
        justify-content: flex-start;
        width: 100%;
        flex-wrap: wrap;
        max-height: 600px;
        overflow: auto;

        .doc {
            padding: 2rem 1rem;
            margin: 0.5rem;
            border: 1px solid #DEDEDE;
            border-radius: 5px;
            box-shadow: 0 5px 5px #DEDEDE;
            cursor: pointer;
            position: relative;

            .select {
                width: 1.2rem;
                height: 1.2rem;
                border-radius: 50%;
                border: 1px solid #DEDEDE;
                position: absolute;
                overflow: hidden;
                top: 0.5rem;
                right: 0.5rem;

                &.active {
                    img {
                        opacity: 1;

                        &:hover {
                            opacity: 1;
                        }
                    }
                }

                img {
                    opacity: 0;
                    height: 120%;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    transition: 0.5s;

                    &:hover {
                        opacity: 0.5;
                        transition: 0.5s;
                    }
                }
            }
        }
    }

    .footer-certified {
        width: 100%;
        justify-content: space-between;
        align-items: center;
        margin-top: 1rem;

        .side {
            font-size: 0.7rem;
            flex-grow: 1;
        }
        .ctn-cta {
            width: auto;
            margin-top: 0;
            .btn {
                margin-top: 0;
            }
        }
    }
}

</style>




// WEBPACK FOOTER //
// Certification.vue?3ff1e96e